<div class="modal-overlay" (click)="onClose()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>Layout</h3>
      <div class="header-actions">
        <button class="icon-btn" (click)="regenerateOptions()" title="Regenerate options">
          <nw-icon type="refresh" [size]="18" color="#374151"></nw-icon>
        </button>
        <button class="close-btn" (click)="onClose()" title="Close">&times;</button>
      </div>
    </div>

    <div class="modal-body">
      <!-- Left: Recommender -->
      <div class="panel panel-left">
        <div class="panel-label">Options</div>
        <div class="options-list">
          <div
            class="option-item"
            *ngFor="let scene of optionScenes; let i = index"
            [class.selected]="selectedIndex === i"
            (click)="selectOption(i)"
          >
            <div class="option-canvas-wrap">
              <div #optionCanvas class="option-canvas"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Center: Preview -->
      <div class="panel panel-center">
        <div class="preview-wrap">
          <div #previewCanvas class="preview-canvas"></div>
        </div>
        <div class="preview-footer">
          <button class="btn btn-primary" (click)="applyLayout()">Apply</button>
        </div>
      </div>

      <!-- Right: Cell Editor -->
      <div class="panel panel-right">
        <div class="panel-label">Cell Editor</div>
        <div class="editor-tree" *ngIf="editorTree">
          <ng-container
            *ngTemplateOutlet="treeNode; context: { node: editorTree, depth: 0 }"
          ></ng-container>
        </div>
        <div class="editor-empty" *ngIf="!editorTree">
          No layout definition
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Recursive tree template -->
<ng-template #treeNode let-node="node" let-depth="depth">
  <div class="tree-node" [style.paddingLeft.px]="depth * 16">
    <div class="node-header" (click)="toggleNode(node)">
      <nw-icon
        *ngIf="node.children.length"
        [type]="node.expanded ? 'expand_more' : 'chevron_right'"
        [size]="14"
        color="#6b7280"
      ></nw-icon>
      <span class="node-label">{{ node.label }}</span>
      <span class="node-type" *ngIf="node.type">{{ node.type }}</span>
    </div>

    <div class="node-fields" *ngIf="node.expanded">
      <div class="field-row" *ngIf="node.definition.type">
        <span class="field-label">type</span>
        <select
          [value]="node.definition.type"
          (change)="updateNodeField(node, 'type', $any($event.target).value)"
        >
          <option value="row">row</option>
          <option value="column">column</option>
          <option value="grid">grid</option>
        </select>
      </div>

      <div class="field-row" *ngIf="node.definition.padding !== undefined">
        <span class="field-label">padding</span>
        <input
          type="number"
          step="0.01"
          min="0"
          max="0.5"
          [value]="node.definition.padding"
          (change)="updateNodeField(node, 'padding', +$any($event.target).value)"
        />
      </div>

      <div class="field-row" *ngIf="node.definition.gap !== undefined">
        <span class="field-label">gap</span>
        <input
          type="number"
          step="0.01"
          min="0"
          max="0.5"
          [value]="node.definition.gap"
          (change)="updateNodeField(node, 'gap', +$any($event.target).value)"
        />
      </div>

      <div class="field-row" *ngIf="node.definition.alignment">
        <span class="field-label">alignment</span>
        <select
          [value]="node.definition.alignment"
          (change)="updateNodeField(node, 'alignment', $any($event.target).value)"
        >
          <option value="start">start</option>
          <option value="center">center</option>
          <option value="end">end</option>
        </select>
      </div>
    </div>

    <div class="node-children" *ngIf="node.expanded && node.children.length">
      <ng-container *ngFor="let child of node.children">
        <ng-container
          *ngTemplateOutlet="treeNode; context: { node: child, depth: depth + 1 }"
        ></ng-container>
      </ng-container>
    </div>
  </div>
</ng-template>
